import React, { useState } from 'react'
import { FiCopy } from 'react-icons/fi'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css';  

const APIContent = (props) => {

    const [copied, setCopied] = useState("KWEW9838GG76TBGHJBJBJ48UOIJROJQWUROIRJORJQJRQRJOIRJ")

  return (
    <>
        <div className='api'>
            <div className='api__container'>
                <h5 className="api__title"> API Key</h5>

                <div className="api__key">
                    <p className='api_'>KWEW9838GG76TBGHJBJBJ48UOIJROJQWUROIRJORJQJRQRJOIRJ</p>

                    <CopyToClipboard text={copied}
                        onCopy={() => setCopied({copied: true})}>
                        <span>
                            <FiCopy 
                                onClick={() => toast.success('Copied!')} 
                            /> 
                        </span>
                    </CopyToClipboard>

                </div>

                
            </div>

            <div className='api__container'>
                <h5 className="api__title"> Secret Key</h5>

                <div className="api__key">
                    <p className='api_'>KWEW9838GG76TBGHJBJBJ48UOIJROJQWUROIRJORJQJRQRJOIRJ</p>

                    <CopyToClipboard text={copied}
                        onCopy={() => setCopied({copied: true})}>
                        <span>
                            <FiCopy 
                                onClick={() => toast.success('Copied!')} 
                            /> 
                        </span>
                    </CopyToClipboard>

                </div>

                
            </div>

        </div>


        <p className="renew__api ">
            Renew API key
        </p>
    </>
  )
}

export default APIContent